(() => {
  const FIND_PAGE_PATH = '/pages/find-waisa';
  const LOCATION_STORAGE_KEY = 'waisa:user-location';
  const CTA_COUNTED_STORAGE_KEY = 'waisa:find-store-cta-counted';
  const LOCATION_MAX_AGE_MS = 5 * 60 * 1000;
  const GEO_OPTIONS = {
    timeout: 10000,
    maximumAge: 300000,
    enableHighAccuracy: false,
  };

  let locationPromise = null;
  let locationInFlight = false;

  function readStoredLocation() {
    try {
      const raw = sessionStorage.getItem(LOCATION_STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (
        !data ||
        typeof data.lat !== 'number' ||
        typeof data.lng !== 'number' ||
        typeof data.ts !== 'number'
      ) {
        return null;
      }
      if (Date.now() - data.ts > LOCATION_MAX_AGE_MS) return null;
      return { lat: data.lat, lng: data.lng };
    } catch {
      return null;
    }
  }

  function storeLocation(coords) {
    try {
      sessionStorage.setItem(
        LOCATION_STORAGE_KEY,
        JSON.stringify({ lat: coords.lat, lng: coords.lng, ts: Date.now() })
      );
    } catch {
      // Ignore quota / private-mode failures.
    }
  }

  function requestUserLocation() {
    const stored = readStoredLocation();
    if (stored) return Promise.resolve(stored);
    if (locationInFlight && locationPromise) return locationPromise;

    locationInFlight = true;
    locationPromise = new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        locationInFlight = false;
        locationPromise = null;
        reject(new Error('unsupported'));
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          storeLocation(coords);
          locationInFlight = false;
          resolve(coords);
        },
        (error) => {
          locationInFlight = false;
          locationPromise = null;
          reject(error);
        },
        GEO_OPTIONS
      );
    });
    return locationPromise;
  }

  window.__waisaRequestUserLocation = requestUserLocation;

  function goToFindPage() {
    const url = new URL(FIND_PAGE_PATH, window.location.origin);
    url.hash = 'near-me';
    window.location.assign(url.href);
  }

  function publishIntent(name, params) {
    if (typeof window.__waisaPublishIntent === 'function') {
      window.__waisaPublishIntent(name, params);
    }
  }

  function requestFindNearest() {
    window.__waisaFindNearestRequested = true;
    try {
      sessionStorage.setItem(CTA_COUNTED_STORAGE_KEY, '1');
    } catch {
      // Ignore quota / private-mode failures.
    }
    publishIntent('find_store', { method: 'cta' });
    const locationRequest = requestUserLocation();
    const locator = document.querySelector('[data-store-locator]');
    if (locator) {
      locator.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.dispatchEvent(new CustomEvent('waisa:find-nearest-store'));
      return;
    }
    locationRequest.finally(goToFindPage);
  }

  if (window.location.hash === '#near-me' || window.__waisaFindNearestRequested) {
    requestUserLocation();
  }

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : event.target.parentElement;
      const button = target?.closest('[data-find-nearest-store]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      requestFindNearest();
    },
    true
  );
})();
